<template>
  <div class="container">
    <div class="qr-block" v-loading="loading" element-loading-text="支付结果检查中~">
      <p class="title">订单编号:{{order_no}}</p>
      <header>
        <i class="kss-icon" :class="params.icon" :style="{color: params.color }"/>
        <span>{{ params.label }}支付</span>
        <p>应付金额:￥{{ fee }}</p>
      </header>
      <div class="wx-main">
        <div class="qr">
          <img class="qr-img" :src="img_qr" alt="wx-pay-qr">
          <div class="footer">
            <i class="kss-icon icon-saoyisao" />
            <div class="flex-cum">
              <p>请使用{{params.label}}扫描</p>
              <p>二维码已完成支付</p>
            </div>
          </div>
        </div>
        <div class="use">
          <img :src="params.useImg" alt="wx-pay-use">
        </div>
      </div>
      <el-button @click="checkStatus" >已完成支付?</el-button>
    </div>
  </div>
</template>

<script>
import { getOrder } from "@/libs/api"
let timer
export default {
  data () {
    return {
      loading: true,
      params: {},
      img_qr: '',
      order_no: '',
      fee: ''
    }
  },
  created() {
    const paramsList = {
      "wx-pay": {
        icon: "icon-wechat",
        label: "微信",
        color: "#51c247",
        useImg: require('@/assets/images/wx-pay-use.jpg')
      },
      "ali-pay":{
        icon: "icon-ziyuan",
        label: "支付宝",
        color: "#009fe9",
        useImg: require('@/assets/images/ali-pay-use.png')
      }
    }
    const { params:{order_no, qr, fee = '100.00'}, name } = this.$route
    this.img_qr = qr
    this.fee = fee
    this.order_no = order_no
    this.params = paramsList[name]
    this.loading = false
    this.refStatus()
  },
  destroyed() {
    clearTimeout(timer)
  },
  methods: {
    refStatus() {
      clearTimeout(timer)
      timer = setTimeout(()=>{
        getOrder(this.order_no).then(({ data })=>{
          this.nextTick(data, false)
          this.refStatus()
        })
      }, 5e3)
    },
    nextTick(data, isError = true) {
      if(data.status > 0) {
        this.$router.push('/mine/order/info/' + this.order_no)
      }
      else if(isError) {
        this.$notify.error('支付还未完成呢!')
        setTimeout(()=>this.loading = false, 5e2)
      }
    },
    checkStatus() {
      this.loading = true
      getOrder(this.order_no).then(({ data })=>
        this.nextTick(data)
      )
    }
  }
}
</script>

<style scoped lang='scss'>
.qr-block{
  width: 96%;
  max-width: 15rem;
  margin: .5rem auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 .1rem #ccc;
  padding: 0 .3rem;
  padding-bottom: .5rem;
  .title{
    line-height: 4;
    font-size: .34rem;
  }
  header{
    display: flex;
    align-items: center;
    padding-bottom: .3rem;
    border-bottom: 4px solid #E94F0F;
    line-height: 1.4;
    font-size: .54rem;
    .kss-icon{
      line-height: 1;
      font-size: 1rem;
      padding-right: .2em
    }
    p{
      font-size: .54rem;
      line-height: 1.4;
      // padding-top: .1em;
      padding-left: .4em;
      font-weight: 300;
      color: #E94F0F;
    }
  }
  .footer{
    width: 100%;
    background-color: #445F85;
    display: flex;
    align-items: center;
    padding: .2rem .34rem;
    .kss-icon{
      color: #fff;
      font-size: 1rem;
      margin-right: .2rem;
    }
    .flex-column{
      display: flex;
      flex-direction: column;
    }
    p{
      color: #fff;
      font-size: .34rem;
      line-height: 2;
    }
  }
  .wx-main{
    margin-top: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: .5rem;
    .qr{
      display: flex;
      flex-direction: column;
    }
    .use img, .use{
      // height: 100%;
      width: 100%
    }
    .use{
      width: 45%;
    }
  }
}
</style>